import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TablesComponent } from './tables.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzResizableModule } from "ng-zorro-antd/resizable";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzTagModule } from "ng-zorro-antd/tag";
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSpaceModule } from "ng-zorro-antd/space";
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';


@NgModule({
  declarations: [TablesComponent],
  imports: [
    CommonModule,
    FormsModule,
    NzTableModule,
    NzDropDownModule,
    NzButtonModule,
    NzCheckboxModule,
    NzEmptyModule,
    NzIconModule,
    NzResizableModule,
    NzDatePickerModule,
    NzSkeletonModule,
    NzSpinModule,
    NzTagModule,
    NzAvatarModule,
    NzCardModule,
    NzSpaceModule,
    NzToolTipModule
  ],
  exports: [TablesComponent]
})
export class TablesModule {}
